import React from 'react';
import { connect } from 'react-redux';
import preload from 'redux-preload';
import Radium from 'radium';

import WorkshopCategoryTile from '../workshop_category_tile';

import { fetchWorkshops } from './actions';

const RPT = React.PropTypes;

@connect(({ workshops: { workshopCategories } }) => ({ workshopCategories }))
@preload(fetchWorkshops)
@Radium
export default class Workshops extends React.Component {
  static propTypes = {
    workshopCategories: RPT.arrayOf(RPT.shape({
      name: RPT.string.isRequired,
      workshops: RPT.arrayOf(RPT.shape)
    })).isRequired
  };

  render() {
    const { workshopCategories } = this.props;

    return (
      <div style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'space-around' }}>
        { workshopCategories.map(category =>
          <WorkshopCategoryTile key={`category-${category.id}`} {...category} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/workshops/index.jsx